<template>
  <div class="mygame-wrap">
    <!-- <div class="header">
        <img src="@/assets/images/ios/recommend/return.png" alt="" @click="goback">
        <span>我的游戏</span>
    </div>-->
    <div class="con">
      <gameli v-for="(item,ind) in gamelist" :key="ind" :game="item" :uuid="uuid"></gameli>
    </div>
  </div>
</template>

<script>
import gameli from "@/components/ios/gameli.vue";
import { zoom } from "@/utils/base.js";
export default {
  data() {
    return {
      gamelist: [],
      uuid: ""
    };
  },
  components: {
    gameli
  },
  created() {
    this.uuid = this.$route.query.uuid;
    document.title = "我的游戏";
    this.getlist();
  },
  methods: {
    getlist() {
      this.$http
        .get(`/apiserv/qTLN2Nec/Frontend/myGame/ios/getAll?uuid=${this.uuid}`)
        .then(res => {
          if (res.data.return_code == 200) {
            this.gamelist = res.data.data;
          }
        });
    },
    goback() {
      // ios返回的方法
      window.webkit.messageHandlers.webNavigationBack.postMessage("");
    }
  },
  mounted() {
    zoom();
  }
};
</script>
<style scoped  lang="less">
.mygame-wrap {
  width: 100%;
  height: 100%;
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
  position: relative;
}
.header {
  position: fixed;
  width: 100%;
  height: 0.4rem;
  background: #fff;
  display: flex;
  img {
    width: 0.25rem;
    height: 0.25rem;
    margin-left: 0.1rem;
    z-index: 10;
    margin-top: 0.07rem;
  }
  span {
    display: inline-block;
    width: 100%;
    margin-left: -0.35rem;
    line-height: 0.4rem;
    text-align: center;
    font-size: 0.17rem;
    z-index: 9;
  }
}
</style>